import api from './api';

const citiesService = {
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.stateId) queryParams.append('stateId', params.stateId);

    const response = await api.get(`/city/get-city?${queryParams.toString()}`);
    return {
      cities: response.data.data || [],
      pagination: response.data.pagination || { total: 0, page: 1, pages: 1, limit: 50 },
    };
  },

  getByState: async (stateId) => {
    const response = await api.get(`/city/get-city/${stateId}`);
    return response.data.data || response.data;
  },

  create: async (data) => {
    const response = await api.post('/city/add-city', data);
    return response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/city/update-city/${id}`, data);
    return response.data.data || response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/city/delete-city/${id}`);
    return response.data;
  },
};

export default citiesService;
